import { DeleteOutline, Edit } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import {
  DataGridPremium,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarExportContainer,
  GridCsvExportMenuItem,
  GridPrintExportMenuItem,
  GridExcelExportMenuItem,
} from "@mui/x-data-grid-premium";
import { ptBR as ptBRCore } from "@mui/x-data-grid/locales";
import * as React from "react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useCompany } from "../../components/context/CompanyContext";
import Loading from "../../components/loading/loading";
import "../../global.css";
import { userRequest } from "../../requestMethods";
import { formatTimeDDMMYYY } from "../../util/helper";
import Switch from "@mui/material/Switch";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import CustomGrid from "../../components/grid/CustomGrid";
import RowSwitch from "../../components/grid/RowSwitch";

export default function UserList() {
  const currentUser = useSelector((state) => state.user.currentUser);
  const { companyId } = useCompany();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (companyId > 0) {
      getUsers();
    }
  }, [companyId]);

  const getUsers = async () => {
    try {
      let url = "";

      setIsLoading(true);
      if (currentUser.isAdmin) {
        url = `${companyId}/users`;
      } else {
        url = `${companyId}/users/find/${currentUser.userId}`;
      }

      const res = await userRequest.get(url);

      const modifiedData = res.data.map((user) => ({
        ...user,
        createdAt: new Date(user.createdAt), // define a data atual ou qualquer data desejada
        updatedAt: new Date(user.updatedAt),
        isAdmin: user.isAdmin ? "Sim" : "Não",
      }));

      setData(modifiedData);
    } catch (error) {
      console.error(error.code);
      if (error.code === 403) {
        nav(`../login`);
      }
    }
    setIsLoading(false);
  };

  const deleteUsr = async (usr, del) => {
    //const res = await userRequest.delete(`${companyId}/users/${usr}`);

    let delToogle = { deleted: null };
    if (del) {
      delToogle = { deleted: new Date(), lastUserUpdate: currentUser.userId };
    }

    const res = await userRequest.put(`${companyId}/users/${usr}`, delToogle);

    if (res.data > 0) {
      getUsers();
    } else {
      Swal.fire("Atenção!", "Erro ao inativar usuário!", "error");
    }
  };
  const onButtonDeleteClick = (row, newValue) => {
    if (currentUser.isAdmin) {
      if (newValue) {
        Swal.fire({
          title: "Tem certeza que deseja inativar?",
          text: "Você não poderá reverter isso!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#EE8253",
          confirmButtonText: "Sim, inativar!",
          cancelButtonColor: "#d33",
          cancelButtonText: "Cancelar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            deleteUsr(row, true);
          } else {
            getUsers();
          }
        });
      } else {
        deleteUsr(row, false);
      }
    } else {
      Swal.fire(
        "Atenção!",
        "Você não tem permissão para inativar usuário!",
        "warning"
      );
    }
  };

  const onButtonEditarClick = (row) => {
    nav(window.location.pathname.replace("tabconfigs", "users") + "/" + row);
  };

  const nav = useNavigate();
  const addRow = () => {
    nav(`../users/new`);
  };

  const columns = [
    {
      field: "userId",
      type: "number",
      headerName: "ID",
      width: 80,
      align: "center",
      headerAlign: "center",
      sortable: true,
      clickable: true,
    },
    {
      field: "name",
      type: "text",
      headerName: "Nome",
      width: 180,
      align: "left",
      headerAlign: "left",
      clickable: true,
      sortable: true,
    },
    {
      field: "email",
      type: "text",
      headerName: "Email",
      width: 200,
      align: "left",
      headerAlign: "left",
      sortable: true,
    },
    {
      field: "contact",
      type: "text",
      headerName: "Contato",
      width: 120,
      align: "center",
      headerAlign: "center",
      sortable: true,
    },
    {
      field: "position",
      type: "text",
      headerName: "Cargo",
      width: 120,
      align: "center",
      headerAlign: "center",
      sortable: true,
    },
    {
      field: "username",
      type: "text",
      headerName: "Usuário",
      width: 120,
      align: "center",
      headerAlign: "center",
      sortable: true,
    },
    {
      field: "cpf",
      type: "text",
      headerName: "CPF",
      width: 120,
      align: "center",
      headerAlign: "center",
      sortable: true,
    },
    {
      field: "isAdmin",
      type: "text",
      headerName: "Administrador",
      width: 120,
      align: "center",
      headerAlign: "center",
      sortable: true,
    },
    {
      field: "createdAt",
      type: "date",
      headerName: "Criada em",
      width: 100,
      align: "left",
      sortable: true,
      format: "dd/MM/yyyy",
    },
    {
      field: "updatedAt",
      type: "date",
      headerName: "Atualizada em",
      width: 100,
      align: "left",
      sortable: true,
      format: "dd/MM/yyyy",
    },
    {
      field: "deleted",
      type: "date",
      headerName: "Ativo",
      width: 80,
      align: "center",
      sortable: true,
      renderCell: ({ row }) => {
        if (!currentUser.isAdmin) return null;
        return (
          <RowSwitch
            value={row.deleted}
            userId={row.userId}
            onChange={onButtonDeleteClick} // sem mudanças
          />
        );
      },
    },
    // {
    //   field: "deletar",
    //   headerName: "",
    //   width: 80,
    //   align: "center",
    //   headerAlign: "center",
    //   renderCell: (params) => {
    //     const handleDeleteClick = (e) => {
    //       e.stopPropagation(); // impede o clique de acionar o onRowClick
    //       onButtonDeleteClick(e, params.row.customerId);
    //     };

    //     return (
    //       <IconButton onClick={handleDeleteClick}>
    //         <DeleteOutline />
    //       </IconButton>
    //     );
    //   },
    // },
  ];
  return (
    <div className="cust-page">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="cust-title">Usuários</div>
          <div className="cust-card">
            <div className="cust-section-header">Lista de Usuários</div>
            <div style={{ padding: "16px" }}>
              <CustomGrid
                toolbarActions={
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<AddIcon />}
                    onClick={addRow}
                    size="small"
                  >
                    Adicionar Usuário
                  </Button>
                }
                gridId="userList"
                rows={data}
                columns={columns}
                pageSize={45}
                checkboxSelection={false}
                onRowClick={(row) => onButtonEditarClick(row.userId)}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
